import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DisplayPriceService } from './display-price.service';
import { BillingFrequencyPipe, DisplayPricePipe } from './display-price.pipe';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from './assets/i18n/en.json';
import { RemoveGoogleTranslatedContentPipe } from './remove-google-translated-content.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'frontend/core-shared',
      baseTranslation: baseTranslation,
    }),
  ],
  exports: [DisplayPricePipe, BillingFrequencyPipe, RemoveGoogleTranslatedContentPipe],
  declarations: [DisplayPricePipe, BillingFrequencyPipe, RemoveGoogleTranslatedContentPipe],
  providers: [DisplayPriceService],
})
export class CoreSharedModule {}
